import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { updateModelInput } from '../../../actions/SearchParameter.Actions';
import MultiChipInput from '../../../components/MultiChipInput';

class ModelInput extends Component {
  constructor(props) {
    super(props);
    this.handleUpdateModelsInput = this.handleUpdateModelsInput.bind(this);
  }

  handleUpdateModelsInput({ results }) {
    const { dispatch } = this.props;
    dispatch(updateModelInput(results));
  }

  render() {
    const { models: { available, input } } = this.props;

    return (
      <MultiChipInput
        label="Search Models"
        data={available}
        bindInput={input}
        onChipDelete={this.handleUpdateModelsInput}
        onChipCreate={this.handleUpdateModelsInput}
        onSelectAll={this.handleUpdateModelsInput}
        onDeleteAll={this.handleUpdateModelsInput}
      />
    );
  }
}

ModelInput.propTypes = {
  dispatch: PropTypes.func.isRequired,
  models: PropTypes.shape({
    available: PropTypes.arrayOf(PropTypes.string).isRequired,
    input: PropTypes.arrayOf(PropTypes.string).isRequired
  }).isRequired
};

function mapStateToProps({ SearchParameter: { models } }) {
  return { models };
}

export default connect(mapStateToProps)(ModelInput);



// WEBPACK FOOTER //
// ./src/containers/Main/BatchEvaluation/ModelInput.jsx